// assets/special-order-modal-handler.js

function initSpecialOrderButtonListeners() {
  const triggers = document.querySelectorAll('.special-order-trigger[data-modal-trigger-for]');

  for (const trigger of triggers) {
    // Remove any existing listener to prevent duplicates before adding a new one.
    // This is a simpler way to handle re-binding if the button gets re-rendered.
    trigger.removeEventListener('click', handleTriggerClick);
    trigger.addEventListener('click', handleTriggerClick);
  }
}

function initSpecialOrderModalCloseListeners() {
  const modals = document.querySelectorAll('.modal.special-order-modal');

  for (const modal of modals) {
    const closers = modal.querySelectorAll('[data-modal-close]');
    for (const closer of closers) {
      closer.removeEventListener('click', handleCloseClick);
      closer.addEventListener('click', handleCloseClick);
    }
  }
}

function handleTriggerClick(event) {
  event.preventDefault();
  const trigger = event.currentTarget;
  const modalId = trigger.dataset.modalTriggerFor;
  const variantId = trigger.dataset.variantId;
  const modal = document.getElementById(modalId);

  if (!modal) {
    console.error(`Special Order Modal: Could not find modal with ID ${modalId}`);
    return;
  }

  const variantInput = modal.querySelector('[data-variant-id-input]');
  if (variantInput) {
    if (variantInput.value !== variantId) {
        variantInput.value = variantId;
    }
  } else {
    console.warn(`Special Order Modal: Could not find variant ID input inside modal ${modalId}`);
  }

  // Only open if it's not already considered open by attribute
  if (!modal.hasAttribute('open')) {
    openModal(modal);
  } else {
    // If it's visually hidden but has 'open', we might need to ensure it's visible
    if (modal.hasAttribute('hidden')) {
        modal.removeAttribute('hidden');
    }
  }
}

function handleCloseClick(event) {
    const modal = event.currentTarget.closest('.modal.special-order-modal');
    if (modal) {
        closeModal(modal);
    }
}

function openModal(modalElement) {
  if (!modalElement) return;
  modalElement.removeAttribute('hidden');
  modalElement.setAttribute('open', '');
  
  // Hide the product gallery expand element
  const galleryExpandElement = document.querySelector('.product-gallery--expand');
  if (galleryExpandElement) {
    galleryExpandElement.style.display = 'none';
  }

  const firstFocusable = modalElement.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  if (firstFocusable) {
      firstFocusable.focus();
  }
}

function closeModal(modalElement) {
   if (!modalElement) return;
   modalElement.setAttribute('hidden', '');
   modalElement.removeAttribute('open');
  // Show the product gallery expand element again
  const galleryExpandElement = document.querySelector('.product-gallery--expand');
  if (galleryExpandElement) {
    galleryExpandElement.style.display = ''; // Reset to default display (block, flex, etc.)
  }
}

// --- Initialization Logic --- 

document.addEventListener('DOMContentLoaded', () => {
  const params = new URLSearchParams(window.location.search);
  // Only run if we have contact_posted and the hash matches the special order form pattern
  if (params.has('contact_posted') && window.location.hash.startsWith('#SpecialOrderContactForm-')) {
    const hashMatch = window.location.hash.match(/^#SpecialOrderContactForm-(\d+)-(\d+)$/);
    if (hashMatch) {
      const [, productId, variantId] = hashMatch;
      if (!params.has('special_order_product') && !params.has('special_order_variant')) {
        params.set('special_order_product', productId);
        params.set('special_order_variant', variantId);
        // Remove the hash and reload with the correct query string
        window.location.href = `${window.location.pathname}?${params.toString()}`;
      }
    }
  }
});

function runInitializations() {
    initSpecialOrderButtonListeners();
    initSpecialOrderModalCloseListeners();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runInitializations);
} else {
  runInitializations();
}

// Listen for section load (Shopify specific for theme editor and dynamic sections)
// This helps re-attach listeners if the section containing the button is re-rendered.
document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    // Use optional chaining for querySelector if section might not have it (though unlikely for valid section element)
    if (section?.querySelector?.('.special-order-trigger')) {
        initSpecialOrderButtonListeners(); 
        initSpecialOrderModalCloseListeners(); 
    }
});

// Handle variant changes: ONLY update the data attribute on the relevant trigger
document.addEventListener('variant:change', (event) => {
   const variant = event.detail.variant;
   const formElement = event.target?.closest('form[data-product-form]');

   if (formElement) {
      const triggerButton = formElement.querySelector('.special-order-trigger');
      if (triggerButton) {
          // Use optional chaining for variant.id as variant itself can be null
          if (variant?.id) { 
              triggerButton.dataset.variantId = variant.id;
          } else {
              triggerButton.dataset.variantId = 'unavailable'; 
          }
      }
   } 
}); 